<template>
  <div>
    <router-view />
  </div>
</template>

<script>
export default{
    data(){
      return{
        data:''
      }
    },
    mounted(){
      //设置 webview 字体大小不受系统修改而改变
      (function(){
          if(window.HiSpaceObject) {
              window.HiSpaceObject.setTextSizeNormal();
          }
      })();
    }
  }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/App.vue